module.exports = __webpack_public_path__ + "img/carefulYes.7bda49e3.svg";